import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { GoalFormParam } from "web_myplann/Goals/Types/GoalFormParam";
import type { InspirationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	dateFormatter,
	ISO_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

export const mapGoalFormToParams = (
	fields: Partial<GoalFormModel>,
	inspirationType?: InspirationTypeEnum,
): URLSearchParams => {
	const params = new URLSearchParams();
	const set = (
		key: GoalFormParam,
		value: string | number | undefined | null,
	) => {
		if (value !== undefined && value !== null) params.set(key, String(value));
	};

	set(GoalFormParam.Category, fields.category);
	set(GoalFormParam.Name, fields.name);
	set(GoalFormParam.TotalValue, fields.totalValue);
	set(GoalFormParam.OwnFunds, fields.ownFunds);
	set(GoalFormParam.LoanAmount, fields.loanAmount);
	set(GoalFormParam.MonthlyRent, fields.monthlyRent);
	set(GoalFormParam.StatePension, fields.statePension);
	set(GoalFormParam.RentYears, fields.rentYears);
	set(GoalFormParam.DrawdownMode, fields.drawdownMode);
	set(GoalFormParam.InspirationType, inspirationType);
	if (fields.dueDate)
		set(GoalFormParam.DueDate, dateFormatter(fields.dueDate, ISO_DATE_FORMAT));

	return params;
};
